module.exports = "<itpx-watermark-card [form]=\"parentForm\"></itpx-watermark-card>\n<itpx-domain-card [form]=\"form\"></itpx-domain-card>\n<itpx-logo-card [message]=\"'onboarding.coverLogo.addLater.restrictions'\" (uploadedImage)=\"coverLogoDetails($event)\"></itpx-logo-card>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/dynamic-onboarding/branding-card/branding-card.component.html
// module id = ./src/app/core/components/dynamic-onboarding/branding-card/branding-card.component.html
// module chunks = main